import React, { useEffect, useState } from "react";
import { Bell, CheckCheck } from "lucide-react";
import { useI18n } from "../../i18n";
import { api } from "../../lib/api";
import { Button } from "../../components/ui/button";

const KIND_COLOR = { success: "hsl(158 64% 28%)", warning: "hsl(38 92% 45%)", info: "hsl(199 89% 48%)", error: "hsl(354 78% 54%)" };

export default function Notifications() {
  const { t, lang } = useI18n();
  const [items, setItems] = useState([]);
  const load = () => api.get("/notifications").then((r) => setItems(r.data)).catch(() => {});
  useEffect(load, []);

  const markAll = async () => { await api.post("/notifications/read-all"); load(); };
  const markOne = async (id) => { await api.post(`/notifications/${id}/read`); load(); };

  return (
    <div className="max-w-3xl mx-auto space-y-5 gc-fade-up">
      <div className="flex items-center justify-between">
        <h1 className="font-display text-2xl font-bold text-[hsl(217_63%_15%)]">{t("nav_notifications")}</h1>
        <Button data-testid="mark-all-read" variant="outline" size="sm" onClick={markAll} className="rounded-full"><CheckCheck className="h-4 w-4 me-1" /> {t("saved")}</Button>
      </div>
      <div className="space-y-2">
        {items.length === 0 && <div className="text-muted-foreground text-sm">—</div>}
        {items.map((n) => (
          <button key={n.id} data-testid={`notif-${n.id}`} onClick={() => markOne(n.id)}
            className={`w-full text-start flex gap-3 rounded-xl border p-4 transition-colors ${n.read ? "border-border bg-card" : "border-[hsl(158_64%_28%)] bg-[hsl(158_64%_98%)]"}`}>
            <div className="mt-0.5"><Bell className="h-4 w-4" style={{ color: KIND_COLOR[n.kind] || KIND_COLOR.info }} /></div>
            <div className="flex-1">
              <div className="font-medium text-sm text-[hsl(217_63%_15%)]">{lang === "ar" ? n.title_ar : n.title_en}</div>
              <div className="text-xs text-muted-foreground mt-0.5">{lang === "ar" ? n.body_ar : n.body_en}</div>
              <div className="text-[10px] text-muted-foreground mt-1 font-mono">{n.created_at?.slice(0, 16).replace("T", " ")}</div>
            </div>
          </button>
        ))}
      </div>
    </div>
  );
}
